<template>
    <div>
        <slot name="modal-trigger"/>
        <v-dialog
            :width="modalWidth"
            outline
            v-model="show"
            persistent
        >
            <v-form ref="form">
                <v-card>
                    <v-card-title class="text-h5" primary-title>
                        <slot name="modal-title"/>
                    </v-card-title>
                    <v-divider/>
                    <v-card-text>
                        <v-flex>
                            <slot name="modal-body"/>
                        </v-flex>
                    </v-card-text>
                    <v-divider/>
                    <v-card-actions>
                        <slot name="cancel-button">
                            <v-btn
                                data-testid="app-modal-cancel-btn"
                                class="app-modal-cancel-btn"
                                v-show="!hideCancel"
                                color="error"
                                :disabled="recording"
                                @click.stop="collapse"
                            >
                            <span>
                                <slot name="cancel-text">Cancel</slot>
                            </span>
                            </v-btn>
                        </slot>
                        <v-spacer/>
                        <slot name="create-button" @click.stop="collapse"/>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
    </div>
</template>

<script>
export default {
  props: {
    value: {
      // This is actually not explicitly passed down, but used to trigger modal open and closing on the 'show' computed property
      type: Boolean
    },
    submitted: {
      // Parents performing a post or patch should pass this prop down for validation resetting
      type: Boolean
    },
    recording: {
      type: Boolean
    },
    width: {
      type: String
    },
    hideCancel: {
      type: Boolean
    }
  },

  methods: {
    collapse() {
      this.show = false;
      this.$emit("collapse");
      this.resetValidation();
    },

    resetValidation() {
      if (this.$refs.form) {
        this.$refs.form.reset();
      }
    }
  },

  computed: {
    show: {
      get() {
        return this.value;
      },
      set(newVal) {
        this.$emit("input", newVal);
      }
    },

    modalWidth() {
      return this.width ? this.width : "50%";
    }
  },

  watch: {
    submitted() {
      this.resetValidation();
    }
  }
};
</script>
